export default {
  myFiles: 'Moja dokumenta',
  newDocument: 'Novi dokument',
  messages: 'Poruke',
  addresses: 'Adrese',
  newAddress: '+ Nova adresa',
  aboutUs: 'O nama',
  addArticle: 'Dodaj artikal',
  addAttribute: 'Dodaj atribut',
  addBank: 'Dodaj banku',
  addBlog: 'Dodaj vest',
  addBrand: 'Dodaj brend',
  addCategory: 'Dodaj kategoriju',
  addCompany: 'Dodaj kompaniju',
  addCountry: 'Dodaj državu',
  addCurrency: 'Dodaj valutu',
  addCustomerBankAccount: 'Dodaj korisnički račun',
  accountDetails: 'Detalji profila',
  addExpressPost: 'Dodaj brzu poštu',
  addInterestsArea: 'Dodaj delatnost',
  addMeasurementUnit: 'Dodaj jedinicu mere',
  addPoll: 'Dodaj anketu',
  addProductSale: 'Dodaj akciju',
  addTab: 'Dodaj tab',
  blog: 'Blog',
  addTown: 'Dodaj grad',
  addToCart: 'Dodaj u korpu',
  addToCart2: 'U korpu',
  docDate: 'Datum dok.',
  account: 'Konto',
  owes: 'Duguje',
  comment: 'Komentar',
  accountNumber: 'Broj računa',
  claims: 'Potražuje',
  paymentTerm: 'Rok plaćanja',
  bookingDateShort: 'Datum knjiž.',
  addUser: 'Dodaj korisnika',
  addVariation: 'Dodaj varijaciju',
  apply: 'Primeni',
  article: 'Proizvod',
  areYouSureArticle: 'Da li ste sigurni da želite da obrišete artikal {article}?',
  areYouSureAttribute: 'Da li ste sigurni da želite da obrišete atribut {attribute}?',
  areYouSureAttributeArticle: 'Da li ste sigurni da želite da obrišete atribut?',
  areYouSureAttributeValue: 'Da li ste sigurni da želite da obrišete vrednost atributa {attributeValue}?',
  areYouSureBank: 'Da li ste sigurni da želite da obrišete banku {bank}?',
  areYouSureBlog: 'Da li ste sigurni da želite da obrišete vest {blog}?',
  areYouSureBrand: 'Da li ste sigurni da želite da obrišete brend {brand}?',
  areYouSureCategory: 'Da li ste sigurni da želite da obrišete kategoriju {category}?',
  areYouSureCompany: 'Da li ste sigurni da želite da obrišete kompaniju {company}?',
  areYouSureCountry: 'Da li ste sigurni da želite da obrišete državu {country}?',
  areYouSureCurrency: 'Da li ste sigurni da želite da obrišete valutu {currency}?',
  areYouSureCustomerBankAccount: 'Da li ste sigurni da želite da obrišete korisnički bankovni račun {bankAccount}?',
  areYouSureExpressPost: 'Da li ste sigurni da želite da obrišete brzu poštu {post}?',
  areYouSureInterestsArea: 'Da li ste sigurni da želite da obrišete delatnost {area}?',
  areYouSureProductSale: 'Da li ste sigurni da želite da obrišete akciju {productSale}?',
  areYouSureSelected: 'Da li ste sigurni da želite da obrišete izabrane zapise?',
  areYouSureTab: 'Da li ste sigurni da želite da obrišete tab {tab}?',
  areYouSureTown: 'Da li ste sigurni da želite da obrišete grad {town}?',
  areYouSureUser: 'Da li ste sigurni da želite da obrišete korisnika {user}?',
  areYouSureCancelOrder: 'Da li ste sigurni da želite da otkažete porudžbinu?',
  areYouSureApproveOrder: 'Da li ste sigurni da želite da odobrite porudžbinu?',
  articleDetails: 'Detalji artikla',
  articleDetailsInfo: 'Unesite detalje artikla',
  articles: 'Artikli',
  attributes: 'Atributi',
  banks: 'Banke',
  blogs: 'Vesti',
  brands: 'Brendovi',
  brand: 'Brend',
  service: 'Servis',
  cancel: 'Otkaži',
  newRequest: 'Novi zahtev',
  contactPerson: 'Kontakt osoba',
  categories: 'Kategorije',
  category: 'Kategorija',
  serialNumber: 'Serijski broj',
  productCode: 'Šifra proizvoda',
  checkout: 'Plaćanje',
  download: 'Preuzmi',
  actions: 'Akcije',
  sales: 'Akcije',
  folderIsEmpty: 'Vaš folder sa dokumentima je prazan',
  physicalPersons: 'Fizička lica',
  goToCheckout: 'Idi na plaćanje',
  choose: 'Izaberite',
  chooseOptions: 'Izaberite opcije',
  contact: 'Kontakt',
  onlineShopping: 'Online kupovina',
  ord: 'Red. br.',
  myAccount2: 'Moj nalog',
  myArticles: 'Moji proizvodi',
  followUsOnSocialMedia: 'Pratite nas na društvenim mrežama',
  deliveryAndPayment: 'Dostava i plaćanje',
  complaintsAndReturns: 'Reklamacije i povraćaji',
  securityAndPrivacy: 'Bezbednost i privatnost',
  termsOfService: 'Uslovi korišćenja i kupovine',
  youNeedHelp: 'Treba vam pomoć?',
  from: 'Od',
  to: 'Do',
  title: 'Naslov',
  markAllAsRead: 'Označi sve kao pročitano',
  faq: 'Često postavljana pitanja',
  howToRegister: 'Kako se registrovati?',
  shoppingHelp: 'Pomoć pri kupovini',
  bonusProgramRules: 'Pravila bonus programa',
  comingSoon: 'Uskoro',
  companies: 'Kompanije',
  countries: 'Države',
  countryDetails: 'Detalji države',
  countryDetailsInfo: 'Unesite detalje države',
  viewFinances: 'Pogledaj finansije',
  coupons: 'Kuponi',
  currencies: 'Valute',
  customerBankAccounts: 'Korisnički računi',
  profileDashboard: 'Kontrolna tabla',
  defaultAddress: 'Sledeće adrese će se po difoltu koristiti na stranici za plaćanje.',
  delete: 'Obriši',
  currentDebt: 'Trenutno zaduženje',
  deleteArticle: 'Obriši artikal',
  paymentTerms: 'Uslovi plaćanja',
  deleteAttribute: 'Obriši atribut',
  debtOutsideCurrency: 'Dug u drugoj valuti',
  deleteBank: 'Obriši banku',
  deleteBlog: 'Obriši vest',
  edit: 'Izmeni',
  approvedDebt: 'Odobreno zaduženje',
  deleteBrand: 'Obriši brend',
  deleteCategory: 'Obriši kategoriju',
  notSetAnyAddressYet: 'Još niste dodali nijednu adresu.',
  deleteCompany: 'Obriši kompaniju',
  deleteCountry: 'Obriši državu',
  deleteCurrency: 'Obriši valutu',
  deleteCustomerBankAccount: 'Obriši korisnički bankovni račun',
  deleteExpressPost: 'Obriši brzu poštu',
  deleteInterestsArea: 'Obriši delatnost',
  deleteProductSale: 'Obriši akciju',
  deleteSelected: 'Obriši izabrano',
  deleteTab: 'Obriši tab',
  deleteTown: 'Obriši grad',
  deleteUser: 'Obriši korisnika',
  deleteVariationImage: 'Da li ste sigurni da želite da obrišete sliku varijacije?',
  details: 'Detalji',
  detailsInfo: 'Unesite detalje',
  editArticle: 'Ažuriraj artikal',
  editAttribute: 'Ažuriraj atribut',
  editBank: 'Ažuriraj banku',
  editBlog: 'Ažuriraj vest',
  editBrand: 'Ažuriraj brend',
  editCategory: 'Ažuriraj kategoriju',
  editCompany: 'Ažuriraj kompaniju',
  editCountry: 'Ažuriraj zemlju',
  editCurrency: 'Ažuriraj valutu',
  editCustomerBankAccount: 'Ažuriraj korisnički račun',
  editExpressPost: 'Ažuriraj brzu poštu',
  editInterestArea: 'Ažuriraj delatnost',
  editPoll: 'Ažuriraj anketu',
  editProductSale: 'Ažuriraj akciju',
  editTab: 'Ažuriraj tab',
  editTown: 'Ažuriraj grad',
  editUser: 'Ažuriraj korisnika',
  expressPosts: 'Brze pošte',
  forgotPassword: 'Zaboravljena lozinka',
  greetings: 'Zdravo',
  homePageTitle: 'Početna',
  highlightedCategories: 'Izdvojeno',
  import: 'Uvezi',
  importArticles: 'Uvezi artikle',
  interestsAreas: 'Delatnosti',
  cancel2: 'ODUSTANI',
  cancel3: 'Odustani',
  login: 'Prijava',
  logIn: 'Prijavi se',
  logout: 'Odjava',
  measurementUnits: 'Jedinice mere',
  myAccount: 'Moj profil',
  delete2: 'OBRIŠI',
  myProfile: 'Profil',
  news: 'Vesti',
  newArticles: 'Novi proizvodi',
  no: 'Ne',
  attention: 'Pažnja',
  warning: 'Upozorenje',
  areYouSureYouWantToDeleteAcc: 'Da li ste sigurni da želite da obrišete svoj nalog? Unesite lozinku da biste obrisali svoj nalog.',
  areYouSureYouWantToDeleteAddress: 'Da li ste sigurni da želite da uklonite izabranu adresu?',
  noItemSelected: 'Nema izabranih stavki',
  noRecords: 'Nema rezultata za izabrane parametre',
  notFound: 'Tražena stranica nije pronađena',
  orderArticles: 'Artikli u korpi',
  orders: 'Porudžbine',
  polls: 'Ankete',
  priceRange: 'Cenovni opseg',
  productSales: 'Akcije',
  recentlyViewdItems: 'Prethodno ste gledali',
  register: 'Registracija',
  resetFilters: 'Poništi filtere',
  rma: 'Prijavljene nepravilnosti (RMA)',
  rmaForm: 'Reklamacije',
  save: 'Sačuvaj',
  saveArticle: 'Sačuvaj artikal',
  saveCategory: 'Sačuvaj kategoriju',
  saveCountry: 'Sačuvaj zemlju',
  search: 'Pretraga',
  find: 'Unesite najmanje 3 karaktera...',
  selectAction: 'Izaberite akciju',
  shoppingCart: 'Korpa',
  tabs: 'Tabovi',
  terms: 'Uslovi korišćenja',
  townDetails: 'Detalji grada',
  townDetailsInfo: 'Unesite detalje o gradu',
  towns: 'Gradovi',
  total: 'Ukupno',
  amount: 'Iznos',
  topBrands: 'Top brendovi',
  userProfile: 'Korisnički profil',
  users: 'Korisnici',
  userArticles: 'Proizvodi odabrani za vas',
  viewAll: 'Vidi sve',
  viewAllFrom: 'Vidi sve iz',
  addToCartSuccessMessage: 'Upravo ste dodali artikal u <br/> korpu: ',
  continueShopping: 'Nastavi kupovinu',
  clearShoppingCart: 'Isprazni korpu',
  updateShoppingCart: 'Ažuriraj korpu',
  goToShoppingCart: 'Idi u korpu',
  wishlist: 'Lista želja',
  addToWishlist: 'Dodaj u listu želja',
  yes: 'Da',
  reviews: 'Recenzija',
  tabReviews: 'Recenzije',
  writeReview: 'Unesite vašu recenziju',
  submitReview: 'Pošalji recenziju',
  anonymous: 'Anonimno',
  linkedArticles: 'Povezani proizvodi',
  quickPreview: 'Brzi pregled',
  loginRegisterTitle: 'Prijava / Kreiranje naloga',
  loginTitle: 'Prijava',
  loginSubTitle: 'Ukoliko imate korisnički nalog, prijavite se.',
  loginButton: 'PRIJAVA',
  registerTitle: 'Zatražite korisnički nalog',
  registerSubTitle: 'Popunite tražene informacije i naš tim će vas kontaktirati u najkraćem roku, nakon čega ćemo vam izraditi korisnički nalog. Hvala!',
  chooseCountry: 'Izaberite zemlju',
  chooseTown: 'Izaberite grad',
  registerSectionLoginDataTitle: 'Podaci za prijavu',
  acceptTerms: 'Prihvatam uslove korišćenja',
  registerSubmit: 'Zatraži nalog',
  repeatOrder: 'Ponovi porudžbinu',
  close: 'Zatvori',
  defaultSort: 'Podrazumevano sortiranje',
  sortByRating: 'Sortiraj po oceni',
  sortByDateOldest: 'Sortiraj po datumu objave: od starijih ka novijim',
  sortByDateNewest: 'Sortiraj po datumu objave: od novijih ka starijim',
  sortByPriceLow: 'Sortiraj po ceni: niža ka višoj',
  sortByPriceHigh: 'Sortiraj po ceni: viša ka nižoj',
  pagingResults: 'Prikazuje se {fromResults} - {toResults} od {totalItems} rezultata',
  showMore: 'Prikaži više',
  productIsAvalible: 'Proizvod je dostupan',
  productIsAvalibleToOrder: 'Proizvod je dostupan po narudžbini',
  deliveryTimeDays: 'Vreme isporuke je {days} dana od porudžbine proizvoda',
  itemIsAvalibleContactRepresentative: 'Artikal je dostupan po narudžbini. Molimo kontaktirajte vašeg prodajnog predstavnika.',
  availableOnRequest: 'Dostupno na upit',
  requestPresentation: 'Zatraži prezentaciju',
  howDoYouRateThisProduct: 'Kako ocenjujete ovaj proizvod?',
  administrator: 'Administrator',
  passwordRecovery: 'Oporavak lozinke',
  enterYourEmailAddressBelowAndWellSendYouInstructions: 'Unesite vašu e-mail adresu ispod i poslaćemo vam uputstva za resetovanje!',
  reset: 'Resetuj',
  remembered: 'Zapamćeno',
  finances: 'Finansije',
  allRightsReserved: 'Sva prava zadržana',
  updateAddress: 'Ažuriraj adresu',
  state: 'Zemlja',
  chooseState: 'Izaberite zemlju',
  listIsEmpty: 'Lista je prazna',
  noResultsAccordingToTheGivenParameters: 'Nema rezultata prema zadatim parametrima',
  termsOfUseIsMandatory: 'Polje Uslovi korišćenja je obavezno',
  resetPassword: 'Reset lozinke',
  accVerificationInProgress: 'Verifikacija naloga u toku',
  accVerification: 'Verifikacija naloga',
  verificationLinkHasExpired: 'Verifikacioni link je istekao. Molimo kontaktirajte naše administratore: support@eurosan.ba ili +387 36 342 220.',
  youHaveJustAddedAnItemToTheCart: 'Upravo ste dodali artikal u korpu:',
  manufacturer: 'Proizvođač',
  productName: 'Naziv proizvoda',
  shoppingCarts: 'Korpe',
  preview: 'Pregled',
  documentName: 'Naziv dokumenta',
  status: 'Status',
  orderNumber: 'Broj porudžbine',
  orderer: 'Naručilac',
  date: 'Datum',
  document: 'Dokument',
  delivery: 'Dostava',
  deliverTo: 'Dostaviti na',
  discount: 'Popust',
  savingsByUsingPromoCode: 'Ušteda korišćenjem promo koda',
  itemAddedToCart: 'Artikal je dodat u korpu.',
  articlesOnSale: 'Artikli na akciji',
  controlPanel: 'Kontrolna tabla',
  tags: 'Tagovi',
  totalAmountWithDelivery: 'Ukupno sa dostavom',
  youHaveNotPlacedAnorderYet: 'Još uvek niste napravili porudžbinu',
  quantity: 'Količina',
  amountWithoutVat: 'Iznos bez PDV-a',
  vatAmount: 'Iznos PDV-a',
  orderNo: 'Porudžbina br',
  days: 'dana',
  time: 'Vreme',
  quantity2: 'KOLIČINA',
  rejectOrd: 'Odbij por',
  approveOrd: 'Odobri por',
  wishListIsEmpty: 'Lista želja je prazna',
  sale: 'AKCIJA',
  totalWithoutTax: 'Ukupno bez poreza',
  sendRequest: 'POŠALJI ZAHTEV',
  promoCode: 'Promo kod',
  send: 'Pošalji',
  registrationCode: 'Šifra prijave',
  created: 'Kreirano',
  giftCard: 'Poklon kod',
  changePassword: 'Promena lozinke',
  emailAddress: 'Email adresa',
  oldPassword: 'Stara lozinka',
  deleteUserAcc: 'OBRIŠI KORISNIČKI NALOG',
  permanentlyDeletedAcc: 'Korisnički nalog će biti trajno obrisan',
  confirmNewPassword: 'Potvrdite novu lozinku',
  passwordConfirmation: 'Potvrda lozinke',
  newPassword: 'Nova lozinka',
  newPassLeaveBlank: 'Nova lozinka (ostavite prazno ako ne želite menjati)',
  currentPassLeaveBlank: 'Trenutna lozinka (ostavite prazno ako ne želite menjati)',
  areasOfInterest: 'Oblasti interesovanja',
  chooseAreaOfInterest: 'Izaberite oblasti interesovanja',
  totalTax: 'Ukupno poreza',
  price: 'Cena',
  price2: 'CENA',
  newAddress2: 'Nova adresa',
  show: 'Prikaži',
  stock: 'Stanje',
  yourTotalDebtIs: 'Vaš ukupan dug iznosi',
  isInStock: 'Na stanju',
  print: 'Štampa',
  signUpForTheNewsletter: 'Prijavite se na bilten',
  latestInformations: 'Dobijajte najnovije informacije o događajima, rasprodajama i ponudama.',
  subscribe: 'Pretplatite se',
  aboutEurosanGroup: 'O Eurosan grupaciji',
  responsibleBusiness: 'Odgovorno poslovanje',
  noDataToAccordingData: 'Nema podataka prema traženim parametrima',
  jobAtEurosan: 'Posao u Eurosanu',
  vpc: 'VPC',
  products: 'proizvoda',
  phoneNumber: 'Broj telefona',
  tax: 'PDV',
  defaultAddress2: 'Podrazumevana adresa',
  totalWithVat: 'Ukupno sa PDV-om',
  totalWithoutVat2: 'Ukupno bez PDV-a',
  summary: 'Rezime',
  warranty: 'Garancija',
  zipCode: 'Poštanski broj',
  indeterminate: 'Neodređeno',
  description: 'Opis',
  forms: {
    notValid: 'Uneti podaci nisu validni!',
    labels: {
      username: 'Korisničko ime',
      abbreviation: 'Skraćenica',
      address: 'Adresa',
      email: 'E-mail adresa',
      articleType: 'Vrsta artikla',
      availableValues: 'Dostupne vrednosti',
      bank: 'Banka',
      bankAccount: 'Bankovni račun',
      brand: 'Brend',
      catalogNumber: 'Kataloški broj',
      category: 'Kategorija',
      code: 'Šifra',
      company: 'Kompanija',
      content: 'Sadržaj',
      country: 'Država',
      countryName: 'Naziv države',
      defaultPrice: 'Podrazumevana cena',
      description: 'Opis',
      fax: 'Faks',
      interestsArea: 'Delatnost',
      isVisibleOnWeb: 'Vidljivo na vebu',
      mpc: 'Maloprodajna cena',
      name: 'Naziv',
      nc: 'Nabavna cena',
      nettoWeight: 'Neto težina',
      officeNumber: 'Broj kancelarije',
      phone: 'Telefon',
      password: 'Lozinka',
      confirmPassword: 'Ponovi lozinku',
      shortDescription: 'Kratak opis',
      symbol: 'Simbol',
      taxGroup: 'Poreska grupa',
      title: 'Naziv',
      town: 'Grad',
      townName: 'Naziv grada',
      unit: 'Jedinica',
      unitOfMeasure: 'Jedinica mere',
      videoUrl: 'Video link',
      vpc: 'Veleprodajna cena',
      firstName: 'Ime',
      lastName: 'Prezime',
    },
    errors: {
      default: 'Došlo je do greške prilikom validacije.',
      email: 'Polje {field} nije validna e-mail adresa.',
      integer: 'Polje {field} mora biti broj.',
      minLength: 'Minimalno {count} karaktera.',
      required: 'Polje {field} je obavezno.',
      sameAs: 'Polja {field} i {field2} se ne podudaraju.',
      url: 'Polje {field} nije validan URL.',
    },
  },
  tables: {
    email: 'E-mail',
    firstLastName: 'Ime i prezime',
    id: 'ID',
    name: 'Naziv',
    phone: 'Telefon',
    town: 'Grad',
    username: 'Korisničko ime',
  },
};
